import { render, staticRenderFns } from "./Redemptions.vue?vue&type=template&id=d6840e9a"
import script from "./Redemptions.vue?vue&type=script&lang=js"
export * from "./Redemptions.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports